import { useFindSupplierMapping } from "~/gen/api/hooks"
import { FindSupplierMappingQueryParams } from "~/gen/api/types"

export const useFindSupplierMappingQuery = ({
  searchSupplier,
}: FindSupplierMappingQueryParams) =>
  useFindSupplierMapping({
    searchSupplier,
  })
